import { H1, P } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import Progress from '../../components/Admin/Progress';
import { ROUTES } from '../../routing';

day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'Progress',
        url: null,
      },
    ]}
  />
);

export default function ProgressPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error, refetch } = useGetCompany(parseInt(id));

  const headerText = `${data?.name} Progress`;

  return (
    <PageWithAsyncData
      isLoading={isLoading}
      error={error}
      retry={refetch}
      noScroll
    >
      <NavbarWithBreadcrumbs name={data?.name} companyId={id} />
      <CompanyPageWrapper
        currentPage={COMPANY_PAGES.PROGRESS}
        contentStyle={{ width: '100%', overflowX: 'auto', maxWidth: '100%' }}
      >
        <H1>{headerText}</H1>
        <P>View learner progress across all company cohorts.</P>
        <Progress />
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
